'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import classNames from 'classnames';

import Button from '@/common/components/shared/button';
import { links } from '@/common/constants/header-links';

import Logo from '~/public/assets/svg/header-logo.svg';

const DesktopHeader = () => {
  const pathname = usePathname();

  return (
    <div className="hidden w-full border-b border-silver-300/70 bg-white/95 px-5 backdrop-blur-xl lg:block xl:px-8">
      <div className="mx-auto flex min-h-20 max-w-360 items-center justify-between gap-4">
        <Link
          href="/"
          aria-label="ویترو - صفحه اصلی"
          className="flex shrink-0 items-center rounded-xl p-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
        >
          <Logo className="h-7 w-30" />
        </Link>

        <nav aria-label="منوی اصلی" dir="rtl" className="min-w-0">
          <ul className="flex items-center gap-1">
            {links.map((item) => {
              const isActive = item.link === pathname;

              return (
                <li key={item.label} className="shrink-0">
                  <Link
                    href={item.link || ''}
                    aria-current={isActive ? 'page' : undefined}
                    className={classNames(
                      'relative flex min-h-10 items-center justify-center rounded-full px-2.5 text-xs font-semibold transition-colors duration-200 xl:px-3 xl:text-sm',
                      isActive
                        ? "text-primary-600 after:absolute after:bottom-1 after:left-1/2 after:h-0.5 after:w-1/2 after:-translate-x-1/2 after:rounded-full after:bg-primary-500 after:content-['']"
                        : 'text-gray-wenge hover:text-cola-500'
                    )}
                  >
                    {item.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        <Button
          id="vendor-login"
          className="!min-h-11 !shrink-0 !rounded-full !px-5 !text-xs xl:!text-sm"
          target="_blank"
          rel="noopener noreferrer"
          link={process.env.NEXT_PUBLIC_WITRO_APP_URL}
          type="black"
          variant="outlined"
        >
          ورود و ثبت نام فروشندگان
        </Button>
      </div>
    </div>
  );
};

export default DesktopHeader;
